import TopMenuItemConfig from '@app/components/ProductFinder/TopMenu/types';

export const findOptionBySlug = (
  options,
  searchSlug
): TopMenuItemConfig | null =>
  options.find(({ slug }) => slug === searchSlug) || null;

export default (
  menuConfig: TopMenuItemConfig[],
  urlChunks: string[]
): TopMenuItemConfig | null => {
  let activeItem;
  for (let i = 0; i < urlChunks.length; i += 1) {
    activeItem = findOptionBySlug(
      activeItem ? activeItem.children : menuConfig,
      urlChunks[i]
    );
    if (!activeItem) {
      return null;
    }
  }
  return activeItem;
};
